import VueGtag from 'vue-gtag';
export const registerGA = (config) => {
    const { app, router, id } = config;
    if (router) {
        app.use(VueGtag, { config: { id } }, router);
    }
    else {
        app.use(VueGtag, { config: { id } });
    }
};
//# sourceMappingURL=registerGA.js.map